<template>
	<v-card style="min-height: 250px;">
		<v-card-title>Selección de ícono</v-card-title>
		<v-divider></v-divider>
		<v-card-text>
			<div class="pa-3 text-center">
				<div class="icono seleccionado">
					<VIcono v-model="value" tamaño="50px"></VIcono>
				</div>
			</div>
			<div class="d-flex">
				<div class="contenedor-iconos">
					<v-subheader>Estilo contorneado</v-subheader>
					<div
						v-for="i in íconos"
						:key="`icono-outline-${i.identificador}`"
						class="icono"
						:class="{ 'seleccionado': value.estilo === 'contorneado' && value.identificador === i.identificador }"
						@click="seleccionar('contorneado', i.identificador)"
					>
						<figure>
							<img :src="`/iconos/heroicons/outline/${i.identificador}.svg`">
						</figure>
					</div>
				</div>
				<div class="contenedor-iconos">
					<v-subheader>Estilo sólido</v-subheader>
					<div
						v-for="i in íconos"
						:key="`icono-solid-${i.identificador}`"
						class="icono"
						:class="{ 'seleccionado': value.estilo === 'sólido' && value.identificador === i.identificador }"
						@click="seleccionar('sólido', i.identificador)"
					>
						<figure>
							<img :src="`/iconos/heroicons/solid/${i.identificador}.svg`">
						</figure>
					</div>
				</div>
			</div>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="green darken-1"
				text
				@click="finalizar"
			>
				Finalizar
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import VIcono from '@/components/base/VIcono.vue'
import iconosContorneados from '@/components/iconosContorneados'
import iconosSolidos from '@/components/iconosSolidos'
import Íconos from '@/components/iconos.js'

export default {
	name: 'IconosSeleccion',

	data: () => ({
		iconosContorneados: iconosContorneados,
		iconosSolidos: iconosSolidos,
		íconos: Íconos,
		valorInicial: {
			estilo: '',
			identificador: ''
		}
	}),

	props: {
		value: {
			type: Object,
			required: true
		}
	},

	components: {
		VIcono,
	},

	methods: {
		seleccionar: function(estilo, identificador) {
			this.$set(this.value, 'estilo', estilo)
			this.$set(this.value, 'identificador', identificador)
		},
		finalizar: function() {
			this.$emit('finalizar')
		},
	}
}
</script>

<style scoped>
.contenedor-iconos {
	flex-grow: 1;
	text-align: center;
	padding: 10px;
}

.contenedor-iconos {
	border: 1px solid #DDD;
}

.contenedor-iconos:last-child {
	border-left: none;
}

.icono {
	border: 1px solid #DDD;
	display: inline-block;
	padding: 10px;
	margin: 3px;
}

.icono.seleccionado {
	outline: 3px solid #0000ff;
}

.icono:hover {
	outline: 3px solid #0000ffaa;
	cursor: pointer;
}

.icono > figure > img {
	width: 30px;
	height: 30px;
}
</style>